import {call, put, takeEvery } from "redux-saga/effects";

import {
  POST_GRAFANA_ENABLE_DISABLE_ALERTS,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS,
  GET_GRAFANA_ALERTS,
  GET_GRAFANA_DEFAULT_THRESHOLD,
  GET_GRAFANA_RESOURCE_BY_ID,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  POST_GRAFANA_ALERT,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  POST_GRAFANA_SERVICE_MAPPING,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES,
  GET_GRAFANA_RESOURCES,
  GET_RESCAN_STATUS_GRAFANA,
  POST_UPDATE_GRAFANA_THRESHOLD,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD, GET_GRAFANA_RESCAN,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_GRAFANA_THRESHOLD,
  GET_GRAFANA_ALL_EXTERNAL_SERVICES,
  GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS,
  POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
GET_GRAFANA_NON_KEY_TRANSACTIONS
} from "./actionTypes";

import {
    postGrafanaEnableDisableAlertsSuccess,
    postGrafanaEnableDisableAlertsFail,
    postGrafanaCreateResourceAlertsSuccess,
    postGrafanaCreateResourceAlertsFail,
    postGrafanaCreateDynamicAlertSuccess,
    postGrafanaCreateDynamicAlertFail,
    getGrafanaAlertsFail,
    getGrafanaAlertsSuccess,
    getGrafanaDynamicAlertsFail,
    getGrafanaDynamicAlertsSuccess,
    getGrafanaMissingDynamicAlertsFail,
    getGrafanaMissingDynamicAlertsSuccess,
    getGrafanaDefaultThresholdFail,
    getGrafanaDefaultThresholdSuccess,
    getGrafanaResourceByIdFail,
    getGrafanaResourceByIdSuccess,
    getGrafanaResourcesDefaultThresholdByIdFail,
    getGrafanaResourcesDefaultThresholdByIdSuccess,
    postGrafanaAlertFail,
    postGrafanaAlertsSuccess,
    getGrafanaRescanFail,
    getGrafanaRescanSuccess,
    getGrafanaMissingAlertByResourceIdFail,
    getGrafanaMissingAlertsByResourceIdSuccess,
    getGrafanaAllResourceAlertsPageFail,
    getGrafanaAllResourceAlertsPageSuccess,
    getGrafanaAllResourceAlertsCountPageFail,
    getGrafanaAllResourceAlertsCountPageSuccess,
    postGrafanaServiceMappingFail,
    postGrafanaServiceMappingSuccess,
    postGrafanaResourceOpsGenieTeamMappingFail,
    postGrafanaResourceOpsGenieTeamMappingSuccess,
    postGrafanaResourcePagerdutyMappingFail,
    postGrafanaResourcePagerdutyMappingSuccess,
    getGrafanaResourcesFail,
    getGrafanaResourcesSuccess,
    getAllOrgGrafanaResourceTypesFail,
    getAllOrgGrafanaResourceTypesSuccess,
    getRescanStatusGrafanaFail,
    getRescanStatusGrafanaSuccess,
    postUpdateGrafanaThresholdFail,
    postUpdateGrafanaThresholdSuccess,
    postEnableDisableGrafanaThresholdFail,
    postEnableDisableGrafanaThresholdSuccess,
    getGrafanaThresholdFail,
    getGrafanaThresholdSuccess,
    getGrafanaAllExternalServicesPageSuccess,
    getGrafanaAllExternalServicesPageFail,
    getGrafanaAllBusinessTransactionsSuccess,
    getGrafanaAllBusinessTransactionsFail,
    getGrafanaNonKeyTransactionsFail,
    getGrafanaNonKeyTransactionsSuccess,
    getMissingGrafanaAlertsByResourceIDSuccess,
    getMissingGrafanaAlertsByResourceIDFail,
    postMarkNonKeyGrafanaTransactionAsBusinessTransactionSuccess,
    postMarkNonKeyGrafanaTransactionAsBusinessTransactionFail
} from "./actions";

 import {
    postGrafanaEnableDisableAlertsUrl,
    postGrafanaCreateResourceAlertsUrl,
    postGrafanaCreateDynamicAlertUrl,
    getGrafanaAlertUrl,
    getGrafanaDynamicAlertsUrl,
    getGrafanaMissingDynamicAlertsUrl,
    getGrafanaDefaultThresholdUrl,
    getGrafanaResourceDefaultThresholdByIdUrl,
    postGrafanaAlertUrl,
    getGrafanaRescanUrl,
    getGrafanaMissingAlertByResourceIdUrl,
    getGrafanaAllResourceAlertsPageUrl,
    getGrafanaAllResourceAlertsCountPageUrl,
    getGrafanaAllBusinessTransactionAlertsUrl,
    getGrafanaAllExternalServicesURL,
    postGrafanaServiceMappingUrl,
    postGrafanaResourceOpsgenieTeamMappingUrl,
    postGrafanaResourcePagerdutyServiceMappingUrl,
    getGrafanaResourcesUrl,
    getAllOrgGrafanaResourceTypesUrl,
    getRescanStatusGrafanaUrl,
    postUpdateGrafanaThresholdUrl,
    postEnableDisableGrafanaThresholdUrl,
    getGrafanaResourceByIDUrl,
    getGrafanaThresholdUrl,
    getGrafanaNonKeyTransactionsByParentResourceUrl,
    postMarkNonKeyGrafanaTransactionAsBusinessTransactionUrl
} from "helpers/fakebackend_helper";


  function* onPostEnableDisableGrafanaThreshold({payload:data}) {
    try{
      const response = yield call(postEnableDisableGrafanaThresholdUrl, data) 
      yield put(postEnableDisableGrafanaThresholdSuccess(response));
    } catch(error) {
      yield put(postEnableDisableGrafanaThresholdFail(error));
    }
  }

  function* onPostUpdateGrafanaThreshold({payload:data}) {
    try{
      const response = yield call(postUpdateGrafanaThresholdUrl, data)
      yield put(postUpdateGrafanaThresholdSuccess(response))
    } catch(error) {
      yield put(postUpdateGrafanaThresholdFail(error))
    }
  }

  function* onGetRescanStatusGrafana() {
    try{
      const response = yield call(getRescanStatusGrafanaUrl)
      yield put(getRescanStatusGrafanaSuccess(response))
    } catch(error) {
      yield put(getRescanStatusGrafanaFail(error))
    }
  } 

  function* onGetAllOrgGrafanaResourceTypes() {
    try{
      const response = yield call(getAllOrgGrafanaResourceTypesUrl)
      yield put(getAllOrgGrafanaResourceTypesSuccess(response))
    } catch(error) {
      yield put(getAllOrgGrafanaResourceTypesFail(error))
    }
  }

  function* onGetGrafanaResources() {
    try{
      const response = yield call(getGrafanaResourcesUrl)
      yield put(getGrafanaResourcesSuccess(response))
    } catch(error) {
      yield put(getGrafanaResourcesFail(error))
    }
  }

  function* onPostGrafanaServiceMapping(data) {
    try{
      const response = yield call(postGrafanaServiceMappingUrl, data.payload)
      yield put(postGrafanaServiceMappingSuccess(response))
      window.location.reload()
    } catch(error) {
      yield put(postGrafanaServiceMappingFail(error))
    }
  }

  function* onPostGrafanaResourceOpsgenieTeamMapping(data) {
    try{
      const response = yield call(postGrafanaResourceOpsgenieTeamMappingUrl, data.payload)
      yield put(postGrafanaResourceOpsGenieTeamMappingSuccess(response));
      window.location.reload()
    } catch(error) {
      yield put(postGrafanaResourceOpsGenieTeamMappingFail(error))
    }
  }

  function* onPostGrafanaResourcePagerdutyServiceMapping(data) {
    try{
      const response = yield call(postGrafanaResourcePagerdutyServiceMappingUrl, data.payload) 
      yield put(postGrafanaResourcePagerdutyMappingSuccess(response));
      window.location.reload()
    } catch(error) {
      yield put(postGrafanaResourcePagerdutyMappingFail(error))
    }
  }

  function* onGetGrafanaAllResourceAlertsPage({payload:data}) {
    try{
      const response = yield call(getGrafanaAllResourceAlertsPageUrl, data);
      yield put(getGrafanaAllResourceAlertsPageSuccess(response));
    } catch(error) {
      yield put(getGrafanaAllResourceAlertsPageFail(error))
    }
  }

  function* onGetGrafanaAllResourceAlertsCountPage({payload:data}) {
    try{
      const response = yield call(getGrafanaAllResourceAlertsCountPageUrl, data)
      yield put(getGrafanaAllResourceAlertsCountPageSuccess(response));
    } catch(error) {
      yield put(getGrafanaAllResourceAlertsCountPageFail(error))
    }
  }

  function* onGetGrafanaMissingAlertByResourceId(monitored_resource_id) {
    try{
      const response = yield call(getGrafanaMissingAlertByResourceIdUrl, monitored_resource_id)
      yield put(getGrafanaMissingAlertsByResourceIdSuccess(response))
    } catch(error) {
      yield put(getGrafanaMissingAlertByResourceIdFail(error))
    } 
  }
  
  function* onGetGrafanaRescan() {
    try{
      const response = yield call(getGrafanaRescanUrl);
      yield put(getGrafanaRescanSuccess(response))
    } catch(error) {
      yield put(getGrafanaRescanFail(error))
    }
  }

  function* onPostGrafanaAlert({payload:data}) {
    try{
      const response = yield call(postGrafanaAlertUrl, data)
      yield put(postGrafanaAlertsSuccess(response))
    } catch(error) {
      yield put(postGrafanaAlertFail(error))
    }
  }

  function* onGetGrafanaResourceDefaultThresholdById(data) {
    try{
      const response = yield call(getGrafanaResourceDefaultThresholdByIdUrl, data.payload)
      yield put(getGrafanaResourcesDefaultThresholdByIdSuccess(response))
    } catch(error) {
      yield put(getGrafanaResourcesDefaultThresholdByIdFail(error))
    } 
  }

  function* onPostGrafanaEnableDisableAlerts({payload: {data}}){
    try{
      const response = yield call(postGrafanaEnableDisableAlertsUrl, data)
      yield put(postGrafanaEnableDisableAlertsSuccess(response));
    } catch(error) {
      yield put(postGrafanaEnableDisableAlertsFail(error))
    }
  }

  function* onPostGrafanaCreateResourceAlerts({payload: {data}}){
    try{
      const response = yield call(postGrafanaCreateResourceAlertsUrl, data)
      yield put(postGrafanaCreateResourceAlertsSuccess(response));
    } catch(error) {
      yield put(postGrafanaCreateResourceAlertsFail(error))
    }
  }

  function* onPostGrafanaCreateDynamicAlert({payload: {data}}){
    try{
      const response = yield call(postGrafanaCreateDynamicAlertUrl, data)
      yield put(postGrafanaCreateDynamicAlertSuccess(response));
    } catch(error) {
      yield put(postGrafanaCreateDynamicAlertFail(error))
    }
  }

  function* onGetGrafanaAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getGrafanaAlertUrl, monitored_resource_id)
      yield put(getGrafanaAlertsSuccess(response));
    } catch(error) {
      yield put(getGrafanaAlertsFail(error))
    }
  }

  function* onGetGrafanaDynamicAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getGrafanaDynamicAlertsUrl, monitored_resource_id)
      yield put(getGrafanaDynamicAlertsSuccess(response))
    } catch(error) {
      yield put(getGrafanaDynamicAlertsFail(error));
    }
  }

  function* onGetGrafanaMissingDynamicAlerts(monitored_resource_id) {
    try{
      const response = yield call(getGrafanaMissingDynamicAlertsUrl, monitored_resource_id)
      yield put(getGrafanaMissingDynamicAlertsSuccess(response))
    } catch(error){
      yield put(getGrafanaMissingDynamicAlertsFail(error));
    }
  }

  function* onGetGrafanaDefaultThreshold(threshold_type) {
    try{
      const response = yield call(getGrafanaDefaultThresholdUrl, threshold_type)
      yield put(getGrafanaDefaultThresholdSuccess(response))
    } catch(error) {
      yield put(getGrafanaDefaultThresholdFail(error))
    }
  }

  function* onGetGrafanaThreshold() {
    try{
      const response = yield call(getGrafanaThresholdUrl)
      yield put(getGrafanaThresholdSuccess(response))
    } catch(error) {
      yield put(getGrafanaThresholdFail(error))
    }
  }

  function* onGetGrafanaResourceById({payload:data}) {
    try{
      const response = yield call(getGrafanaResourceByIDUrl,data);
      yield put(getGrafanaResourceByIdSuccess(response));
    } catch(error) {
      yield put(getGrafanaResourceByIdFail(error))
    }
  }

function* onGetGrafanaMissingAlertsByResourceID(monitored_resource_id) {
    try {
        const response = yield call(getGrafanaMissingAlertByResourceIdUrl, monitored_resource_id.payload);
        yield put(getMissingGrafanaAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingGrafanaAlertsByResourceIDFail(error.message));
    }
}

function* onGetGrafanaAllBusinessTransactionsPage({payload:data}) {
    try{
        const response = yield call(getGrafanaAllBusinessTransactionAlertsUrl, data)
        yield put(getGrafanaAllBusinessTransactionsSuccess(response));
    } catch(error) {
        yield put(getGrafanaAllBusinessTransactionsFail(error))
    }
}

function* onGetGrafanaAllExternalServicesPage({payload:data}) {
    try{
        const response = yield call(getGrafanaAllExternalServicesURL, data)
        yield put(getGrafanaAllExternalServicesPageSuccess(response));
    } catch(error) {
        yield put(getGrafanaAllExternalServicesPageFail(error))
    }
}

function* onGetGrafanaNonKeyTransactionsByParentResource({payload:data}) {
    try {
        const response = yield call(getGrafanaNonKeyTransactionsByParentResourceUrl, data)
        yield put(getGrafanaNonKeyTransactionsSuccess(response));
    } catch (error) {
        yield put(getGrafanaNonKeyTransactionsFail(error))
    }
}

function* onPostMarkNonKeyTransactionAsBusinessTransaction({payload:data}) {
    try {
        const response = yield call(postMarkNonKeyGrafanaTransactionAsBusinessTransactionUrl, data)
        yield put(postMarkNonKeyGrafanaTransactionAsBusinessTransactionSuccess(response));
    } catch (error) {
        yield put(postMarkNonKeyGrafanaTransactionAsBusinessTransactionFail(error))
    }
}

  function* GrafanaSaga(){
    yield takeEvery(GET_GRAFANA_RESOURCE_BY_ID, onGetGrafanaResourceById);
    yield takeEvery(POST_GRAFANA_ENABLE_DISABLE_ALERTS, onPostGrafanaEnableDisableAlerts);
    yield takeEvery(POST_GRAFANA_CREATE_RESOURCE_ALERTS, onPostGrafanaCreateResourceAlerts);
    yield takeEvery(GET_GRAFANA_ALERTS, onGetGrafanaAlerts);
    yield takeEvery(GET_GRAFANA_DEFAULT_THRESHOLD, onGetGrafanaDefaultThreshold);
    yield takeEvery(GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID, onGetGrafanaResourceDefaultThresholdById);
    yield takeEvery(POST_GRAFANA_ALERT, onPostGrafanaAlert);
    yield takeEvery(GET_GRAFANA_RESCAN, onGetGrafanaRescan);
    yield takeEvery(GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID, onGetGrafanaMissingAlertByResourceId);
    yield takeEvery(POST_GRAFANA_SERVICE_MAPPING, onPostGrafanaServiceMapping);
    yield takeEvery(POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostGrafanaResourceOpsgenieTeamMapping);
    yield takeEvery(POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostGrafanaResourcePagerdutyServiceMapping);
    yield takeEvery(GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE, onGetGrafanaAllResourceAlertsPage);
    yield takeEvery(GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE, onGetGrafanaAllResourceAlertsCountPage);
    yield takeEvery(GET_GRAFANA_RESOURCES, onGetGrafanaResources);
    yield takeEvery(GET_ALL_ORG_GRAFANA_RESOURCE_TYPES, onGetAllOrgGrafanaResourceTypes);
    yield takeEvery(GET_RESCAN_STATUS_GRAFANA, onGetRescanStatusGrafana);
    yield takeEvery(POST_UPDATE_GRAFANA_THRESHOLD, onPostUpdateGrafanaThreshold);
    yield takeEvery(POST_ENABLE_DISABLE_GRAFANA_THRESHOLD, onPostEnableDisableGrafanaThreshold);
    yield takeEvery(GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID, onGetGrafanaMissingAlertsByResourceID);
    yield takeEvery(GET_GRAFANA_THRESHOLD, onGetGrafanaThreshold);
    yield takeEvery(GET_GRAFANA_ALL_EXTERNAL_SERVICES, onGetGrafanaAllExternalServicesPage);
    yield takeEvery(GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS, onGetGrafanaAllBusinessTransactionsPage);
    yield takeEvery(GET_GRAFANA_NON_KEY_TRANSACTIONS, onGetGrafanaNonKeyTransactionsByParentResource);
    yield takeEvery(POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION, onPostMarkNonKeyTransactionAsBusinessTransaction);
  }

 export default GrafanaSaga;